const createUserToast = (state = null, action) => {
  if (action.type === "SET_CREATE_USER_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_CREATE_USER_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default createUserToast;
